import {
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Box } from "@mui/system";

interface Props {
  columns: number;
  rows?: number;
}

/**
 * Table-shaped placeholder every <Subject>Skeleton in this module renders with
 * its own column count, so each table still has a real sibling skeleton without
 * five copies of the same markup.
 */
const FetcherTableSkeleton = ({ columns, rows = 10 }: Props) => (
  <>
    <TableContainer>
      <Table size="small" sx={{ whiteSpace: "nowrap" }}>
        <TableHead>
          <TableRow>
            {Array.from({ length: columns }).map((_, index) => (
              <TableCell key={index} align="left">
                <Skeleton width={90} />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <TableRow
              key={rowIndex}
              sx={{
                "& > *": {
                  borderBottom: "1px solid rgba(224, 224, 224, 1) !important",
                },
              }}
            >
              {Array.from({ length: columns }).map((__, cellIndex) => (
                <TableCell key={cellIndex} align="left">
                  <Skeleton width="70%" />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>

    <Stack
      spacing={1}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ padding: "12px 16px" }}
    >
      <Box sx={{ flex: 1 }}>
        <Skeleton width={140} height={24} />
      </Box>
      <Skeleton width={220} height={24} />
      <Box sx={{ flex: 1 }} />
    </Stack>
  </>
);

export default FetcherTableSkeleton;
